import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Col,
	Spinner,
	Pagination,
	PaginationItem,
	PaginationLink,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import {
	getPOItemreportslist,
	getPOreportslist,
	SetParams,
} from "../../../store/Reports/actions";
import "../reports.scss";

var date = new Date(),
	y = date.getFullYear(),
	m = date.getMonth();
class POItemReportList extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const { vendor, ...otherParams } = this.props.params;
		var objData = {
			model_name: "PurchaseOrderDetails",
			file_format: 5,
		};
		this.props.getPOreportslist({
			...otherParams,
			objData,
			ParamsData: {
				...this.props.params,
				start_date:
					this.props.params.start_date == null ||
					this.props.params.start_date === ""
						? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
						: this.props.params.start_date,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
						: moment(this.props.params.end_date)
								.add(1, "days")
								.format("YYYY-MM-DD"),
				purchaseorder__requestforquotation:
					this.props.params.requestforquotation != null
						? this.props.params.requestforquotation
						: null,
				purchaseorder__vendor:
					this.props.params.vendor != null
						? this.props.params.vendor
						: null,
			},
		});
	}
	openPage(pageNo) {
		var objData = {
			model_name: "PurchaseOrderDetails",
			file_format: 5,
		};
		this.props.SetParams({ ...this.props.params, page: pageNo });
		this.props.getPOreportslist({
			ParamsData: {
				...this.props.params,
				page: pageNo,
				start_date:
					this.props.params.start_date == null ||
					this.props.params.start_date === ""
						? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
						: this.props.params.start_date,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
						: moment(this.props.params.end_date)
								.add(1, "days")
								.format("YYYY-MM-DD"),
				purchaseorder__requestforquotation:
					this.props.params.requestforquotation != null
						? this.props.params.requestforquotation
						: null,
				purchaseorder__vendor:
					this.props.params.vendor != null
						? this.props.params.vendor
						: null,
			},
			objData,
		});
	}
	ExportExcel() {
		var objData = {
			model_name: "PurchaseOrderDetails",
			file_format: 0,
		};
		this.props.getPOreportslist({
			objData,
			ParamsData: {
				// ...this.props.params,
				start_date:
					this.props.params.start_date == null ||
					this.props.params.start_date === ""
						? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
						: this.props.params.start_date,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
						: moment(this.props.params.end_date)
								.add(1, "days")
								.format("YYYY-MM-DD"),
				purchaseorder__requestforquotation:
					this.props.params.requestforquotation != null
						? this.props.params.requestforquotation
						: null,
				purchaseorder__vendor:
					this.props.params.vendor != null
						? this.props.params.vendor
						: null,
			},
		});
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print">
										<Link
											to="/poreport"
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<div className="float-right">
											<div className="d-inline-block ">
												{/* <ExportToExcel
                          apiData={this.props.PO_ReportData.map(
                            (poItem, key) => {
                              return {
                                "S.No.": key + 1,
                                "PO Date": moment(
                                  poItem["PO Date"]
                                ).format("DD-MM-YYYY"),
                                "PO Code": poItem["PO Code"],
                                "RFQ Code":
                                  poItem["RFQ Code"],

                                "Vendor Name": poItem["Vendor Name"],
                                "Item Name": poItem["Item Name"],
                                "Req Qty": poItem.originalqty,
                                "Recd Qty":
                                  parseInt(poItem.originalqty) -
                                  parseInt(poItem.availableqty),
                                "Balance Qty": poItem.availableqty,
                                Rate: poItem.price,
                                "Amount(Rs)": poItem.gross,
                                "No of Days of PO": parseInt(
                                  (new Date() -
                                    new Date(poItem["PO Date"])) /
                                    (1000 * 60 * 60 * 24)
                                ),
                              };
                            }
                          )}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "PENDING STATUS OF PURCHASE ORDER REPORT",
                            "",
                          ]}
                          fileName="PENDING_STATUS_OF_PURCHASE_ORDER_REPORT"
                        /> */}
												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														this.ExportExcel()
													}>
													<i className="ri-file-excel-2-line"></i>
													<span className="d-none d-inline-block ml-1">
														Excel
													</span>
												</Button>
												{/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
												<Button
													type="button"
													outline
													color="secondary"
													className=" ml-2"
													onClick={() =>
														window.print()
													}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody className="pt-2 card-body printme">
										<div className="text-center">
											<span className="display_none printme">
												<h5 className="card-title-18 pt-2 ">
													SRI LALITHA ENTERPRISES
													INDUSTRIES PVT. LTD
												</h5>
												<p className="card-title-14 pt-2 mb-0">
													Valuthimmapuram Road,
													PEDDAPURAM - 533437, E.G.
													Dist. - AP
												</p>
												<p className="card-title-14 pt-2">
													Phone No.0884-2326661, 62,
													Mobile No.9494127893, Email:
													purchase@sleipl.com,
													lalitharice@gmail.com
												</p>
												<hr />
											</span>
											<h5 className="card-title-16 pt-3 ">
												PENDING STATUS OF PURCHASE ORDER
												REPORT bbbbbb ({" "}
												{moment(
													this.props.params
														.start_date == null ||
														this.props.params
															.start_date === ""
														? new Date(y, m, 1)
														: this.props.params
																.start_date
												).format("DD-MM-YYYY")}{" "}
												TO{" "}
												{moment(
													this.props.params
														.end_date == null ||
														this.props.params
															.end_date === ""
														? new Date()
														: this.props.params
																.end_date
												).format("DD-MM-YYYY")}{" "}
												)
											</h5>
										</div>

										<div className="table-responsive m-0">
											{this.props.loading ? (
												<div className="text-center">
													<Spinner color="primary" />
												</div>
											) : (
												<>
													<Table
														bordered
														hover
														className="mb-0 p-0 table-centered"
														id="table-to-xls">
														<thead className="bg-light text-center ">
															<tr className="bg-light">
																<th
																	style={{
																		width: "2%",
																	}}>
																	<b>S.No.</b>
																</th>
																<th
																	style={{
																		width: "10%",
																	}}>
																	<b>
																		PO Date
																	</b>
																</th>
																<th
																	style={{
																		width: "8%",
																	}}>
																	<b>
																		PO Code
																	</b>
																</th>
																<th
																	style={{
																		width: "8%",
																	}}>
																	<b>
																		RFQ Code
																	</b>
																</th>

																<th
																	style={{
																		width: "15%",
																	}}>
																	<b>
																		Vendor
																		Name
																	</b>
																</th>
																<th
																	style={{
																		width: "10%",
																	}}>
																	<b>
																		Item
																		Name
																	</b>
																</th>
																<th
																	style={{
																		width: "6%",
																	}}>
																	<b>
																		PO Qty
																	</b>
																</th>
																<th
																	style={{
																		width: "6%",
																	}}>
																	<b>
																		Recd Qty
																	</b>
																</th>
																<th
																	style={{
																		width: "5%",
																	}}>
																	<b>
																		Balance
																		Qty
																	</b>
																</th>
																<th
																	style={{
																		width: "10%",
																	}}>
																	<b>Rate</b>
																</th>
																<th
																	style={{
																		width: "10%",
																	}}>
																	<b>
																		Amount(Rs)
																	</b>
																</th>
																<th
																	style={{
																		width: "10%",
																	}}>
																	<b>
																		Sub
																		Location
																	</b>
																</th>
																<th
																	style={{
																		width: "5%",
																	}}>
																	<b>
																		No of
																		Days of
																		PO
																	</b>
																</th>
															</tr>
														</thead>
														<tbody>
															{/* {this.props.loading ? (
                            <>
                              <tr>
                                <td colSpan="12" className="text-center">
                                  <Spinner color="primary" />
                                </td>
                              </tr>
                            </>
                          ) : ( */}
															<>
																{this.props
																	.PO_ReportData
																	.length !==
																0 ? (
																	<>
																		{this.props.PO_ReportData.map(
																			(
																				poItem,
																				key
																			) => (
																				<>
																					<tr
																						key={
																							key
																						}
																						className="text-center">
																						<td>
																							{key +
																								1}
																						</td>
																						<td>
																							{moment(
																								poItem[
																									"PO Date"
																								]
																							).format(
																								"DD-MM-YYYY"
																							)}
																						</td>
																						<td>
																							{
																								poItem[
																									"PO Code"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"RFQ Code"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Vendor Name"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Item Name"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"PO Qty"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Recd Qty"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Balance Qty"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Rate"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Amount(Rs)"
																								]
																							}
																						</td>
																						<td>
																							{
																								poItem[
																									"Sub Location"
																								]
																							}
																						</td>

																						<td>
																							{parseInt(
																								(new Date() -
																									new Date(
																										poItem[
																											"PO Date"
																										]
																									)) /
																									(1000 *
																										60 *
																										60 *
																										24)
																							)}
																						</td>
																					</tr>
																				</>
																			)
																		)}
																	</>
																) : (
																	<tr>
																		<td
																			colSpan="12"
																			className="text-center">
																			<span className="font-size-18 text-danger">
																				Data
																				not
																				available
																			</span>
																		</td>
																	</tr>
																)}
															</>
															{/* )} */}
														</tbody>
													</Table>
													<div className="d-inline-block">
														<Pagination aria-label="Page navigation example">
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page <=
																	1
																}>
																<PaginationLink
																	onClick={(
																		e
																	) =>
																		this.openPage(
																			1
																		)
																	}
																	previous
																	// href="#"
																/>
															</PaginationItem>

															{this.props.params
																.page > 2 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page <=
																		2
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page -
																					2
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page -
																			2}
																	</PaginationLink>
																</PaginationItem>
															)}
															{this.props.params
																.page > 1 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page ===
																		1
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page -
																					1
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page -
																			1}
																	</PaginationLink>
																</PaginationItem>
															)}

															<PaginationItem
																active={true}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page
																		)
																	}
																	// href="#"
																>
																	{
																		this
																			.props
																			.params
																			.page
																	}
																</PaginationLink>
															</PaginationItem>
															{this.props.params
																.page +
																1 <=
																this.props
																	.params
																	.no_of_pages && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			1 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					1
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page +
																			1}
																	</PaginationLink>
																</PaginationItem>
															)}
															{this.props.params
																.page +
																2 <=
																this.props
																	.params
																	.no_of_pages && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			2 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					2
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page +
																			2}
																	</PaginationLink>
																</PaginationItem>
															)}
															{this.props.params
																.page +
																3 <=
																this.props
																	.params
																	.no_of_pages &&
																this.props
																	.params
																	.page <
																	3 && (
																	<PaginationItem
																		disabled={
																			this
																				.props
																				.params
																				.page +
																				3 >
																			this
																				.props
																				.params
																				.no_of_pages
																		}>
																		<PaginationLink
																			onClick={() =>
																				this.openPage(
																					this
																						.props
																						.params
																						.page +
																						3
																				)
																			}
																			// href="#"
																		>
																			{this
																				.props
																				.params
																				.page +
																				3}
																		</PaginationLink>
																	</PaginationItem>
																)}
															{this.props.params
																.page +
																4 <=
																this.props
																	.params
																	.no_of_pages &&
																this.props
																	.params
																	.page <
																	2 && (
																	<PaginationItem
																		disabled={
																			this
																				.props
																				.params
																				.page +
																				4 >
																			this
																				.props
																				.params
																				.no_of_pages
																		}>
																		<PaginationLink
																			onClick={() =>
																				this.openPage(
																					this
																						.props
																						.params
																						.page +
																						4
																				)
																			}
																			// href="#"
																		>
																			{this
																				.props
																				.params
																				.page +
																				4}
																		</PaginationLink>
																	</PaginationItem>
																)}

															<PaginationItem
																disabled={
																	this.props
																		.params
																		.no_of_pages ===
																	this.props
																		.params
																		.page
																}>
																<PaginationLink
																	onClick={(
																		e
																	) =>
																		this.openPage(
																			this
																				.props
																				.params
																				.no_of_pages
																		)
																	}
																	next
																	// href="#"
																/>
															</PaginationItem>
														</Pagination>
													</div>
												</>
											)}
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { params, reportType, Reportdata, PO_ReportData, loading } =
		state.reports;
	return {
		params,
		reportType,
		Reportdata,
		PO_ReportData,
		loading,
	};
};

export default connect(mapStatetoProps, {
	getPOItemreportslist,
	getPOreportslist,
	SetParams,
})(POItemReportList);
